import Swiper from 'swiper'

export default () => {
    var swiper = new Swiper('.mySwiper', {
        slidesPerView: 1.1,
        spaceBetween: 20,
        breakpoints: {
            640: {
                slidesPerView: 1.2,
                spaceBetween: 25,
            },
            768: {
                slidesPerView: 1.4,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
    })
}
